import classNames from "classnames/bind";
import usePartExchangeQuestionsContext from "features/vehicleDetails/providers/partExchangeQuestions/usePartExchangeQuestionsContext";
import { VehicleService } from "services/vehicle/vehicle";

import SectionLabel from "../SectionLabel";
import CalculatorOptionsForm, { CalculatorOptionsFormProps } from "./CalculatorOptionsForm";
import CalculatorStats, { CalculatorStatsProps } from "./CalculatorStats";
import styles from "./FinanceCalculator.module.scss";
import { FinanceCalculatorProvider } from "./context";

const cx = classNames.bind(styles);

export type FinanceCalculatorProps = CalculatorOptionsFormProps &
    CalculatorStatsProps & {
        legacyVehicleId: VehicleService.Vehicle["LegacyVehicleId"];
        enquiryLink: string;
        isCommercial: boolean;
        externalIds: VehicleService.ExternalId[];
    };
const FinanceCalculator = (props: FinanceCalculatorProps) => {
    const { maxDepositAmount } = props;
    const { partExQuestionsAnswersResponse } = usePartExchangeQuestionsContext();

    const hasPX: boolean = !!partExQuestionsAnswersResponse;
    const isPxMoreThanMaxDeposit: boolean =
        hasPX && (partExQuestionsAnswersResponse?.Equity ?? 0) > maxDepositAmount;

    const additionalProps = {
        hasPX,
        isPxMoreThanMaxDeposit,
    };

    return (
        <div className={cx("stack")}>
            <SectionLabel>Finance Calculator</SectionLabel>
            <div className={cx("calculator")}>
                <FinanceCalculatorProvider>
                    <CalculatorOptionsForm {...props} {...additionalProps} />
                    <CalculatorStats {...props} {...additionalProps} />
                </FinanceCalculatorProvider>
            </div>
        </div>
    );
};

export default FinanceCalculator;
